module.exports = __webpack_public_path__ + "img/compay-img.037e9ff3.jpg";